import type { SendResponse } from '@/types/chat'
import { defineComponent, ref } from 'vue'
import { clearChatApiCall } from '@/api/chat'
import { useApiCall } from '@/composables/useApiCall'
import { useMainStore } from '@/store/main'

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const mainStore = useMainStore()

    const {
      // isLoading: isClearLoading,
      // data: clearMessageResponse,
      // error: clearMessageError,
      executeApiCall: clearMessageAction,
    } = useApiCall<SendResponse, any, any>(
      clearChatApiCall,
      true,
    )
    const isLoading = ref(false)
    const clearHistory = async () => {
      isLoading.value = true
      const arr = ['product_faq', 'marketer', 'sales_analyst', 'hr_assistant', 'idea_generator', 'lawyer_light', 'sales_manager']
      for (let i = 0; i < arr.length; i++) {
        await clearMessageAction(
          { assistantType: arr[i] },
        )
      }
      mainStore.deleteHistory = true
      isLoading.value = false
    }
    return {
      mainStore,
      clearHistory,
      isLoading,
    }
  },
})
